import type { IPerson } from "../interfaces/models/IPerson";

/**
 * Person AOP fields as stored today: `areasOfPractice` = `string[]`, optional `aopExpertiseIds`.
 * Legacy object-row shapes are not read here (treated as empty lists).
 */

export function normalizePersonAreasOfPracticeIds(person: IPerson): string[] {
  const raw = person.areasOfPractice as unknown;
  if (!Array.isArray(raw) || raw.length === 0) {
    return [];
  }
  if (typeof raw[0] !== "string") {
    return [];
  }
  return raw.map((x) => String(x).trim()).filter(Boolean);
}

export function normalizePersonAopExpertiseIds(person: IPerson): string[] {
  const direct = (person as { aopExpertiseIds?: unknown }).aopExpertiseIds;
  if (!Array.isArray(direct) || direct.length === 0) {
    return [];
  }
  return direct.map((x) => String(x).trim()).filter(Boolean);
}
